import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CompensationEquityReport } from '~/scenes/PortalModules/Analytics/Rewarding/CompensationEquityReport';
import {
  NavigationRoutingStructure,
  useStructuredModuleRouting,
} from '~/scenes/PortalViews/components/StructuredModuleRouter';

export const useAnalyticsViews = () => {
  const { t } = useTranslation();

  const initialNavigationStructure: NavigationRoutingStructure[] =
    useMemo(() => {
      return [
        // {
        //   path: 'company-dashboard',
        //   label: t('laCompDB'),
        // },
        // {
        //   path: 'team-dashboard',
        //   label: t('laTeamDB'),
        //   subPaths: [
        //     {
        //       path: 'team-report',
        //       label: t('laTeamRep'),
        //     },
        //     {
        //       path: 'absence-calendar',
        //       label: t('laAbsCal'),
        //     },
        //   ],
        // },
        // {
        //   path: 'team-dashboard',
        //   label: t('laHRDB'),
        // },
        // {
        //   path: 'employee-dashboard',
        //   label: t('laEmpDB'),
        // },
        // {
        //   path: 'work-experience-dashboard',
        //   label: t('laWEDB'),
        // },
        {
          path: 'people',
          label: t('laPeople'),
          subPaths: [
            {
              path: 'test',
              label: 'Test',
              component: <>Lorem ipsum</>,
              isAvailable: false,
            },
          ],
        },
        {
          path: 'rewarding',
          label: t('laRewarding'),
          subPaths: [
            {
              path: 'compensation-equity',
              label: t('compensationEquity'),
              component: <CompensationEquityReport />,
            },
          ],
        },
        // {
        //   path: 'performance',
        //   label: t('laPerformance'),
        // },
        // {
        //   path: 'development',
        //   label: t('laDevelopment'),
        // },
        // {
        //   path: 'organization',
        //   label: t('laOrganization'),
        // },
        // {
        //   path: 'succession',
        //   label: t('laSuccPlan'),
        // },
      ];
    }, [t]);

  return useStructuredModuleRouting(initialNavigationStructure);
};
